/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SymbolFundamentalsDataPointDto,
    SymbolFundamentalsDataPointDtoFromJSON,
    SymbolFundamentalsDataPointDtoFromJSONTyped,
    SymbolFundamentalsDataPointDtoToJSON,
} from './SymbolFundamentalsDataPointDto';

/**
 * 
 * @export
 * @interface SymbolFundamentalsTimeSeriesDto
 */
export interface SymbolFundamentalsTimeSeriesDto {
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsTimeSeriesDto
     */
    symbolId: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsTimeSeriesDto
     */
    attributeKey: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsTimeSeriesDto
     */
    periodType: string;
    /**
     * 
     * @type {Array<SymbolFundamentalsDataPointDto>}
     * @memberof SymbolFundamentalsTimeSeriesDto
     */
    data: Array<SymbolFundamentalsDataPointDto>;
}

export function SymbolFundamentalsTimeSeriesDtoFromJSON(json: any): SymbolFundamentalsTimeSeriesDto {
    return SymbolFundamentalsTimeSeriesDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalsTimeSeriesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalsTimeSeriesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolId': json['symbolId'],
        'attributeKey': json['attributeKey'],
        'periodType': json['periodType'],
        'data': ((json['data'] as Array<any>).map(SymbolFundamentalsDataPointDtoFromJSON)),
    };
}

export function SymbolFundamentalsTimeSeriesDtoToJSON(value?: SymbolFundamentalsTimeSeriesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolId': value.symbolId,
        'attributeKey': value.attributeKey,
        'periodType': value.periodType,
        'data': ((value.data as Array<any>).map(SymbolFundamentalsDataPointDtoToJSON)),
    };
}

